module.exports = __webpack_public_path__ + "/login_ui/img/be-b16164cdf2c3e50f35d6f5c63123aef4.svg";